import { h } from 'preact';
import { useContext } from 'preact/hooks';
import { KBContext } from 'widget_main/store';
import Text from 'widget_main/components/Text';

import messages from './messages';
import styles from './kbArticle.scss';

const KBArticle = () => {
  const kb = useContext(KBContext);

  const { articles, currentArticleId } = kb;

  if (!currentArticleId) return null;

  const article = articles?.[currentArticleId];

  if (!article) return null;

  const updatedAtDate = new Date(article.updatedAt);

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  const updatedAtDateLocaleString = updatedAtDate.toLocaleDateString(
    'en-US',
    options,
  );

  return (
    <div className={styles.articleContainer}>
      <h3 className={styles.title}>{article.title}</h3>
      <p className={styles.updatedAt}>
        <Text
          fields={{ date: updatedAtDateLocaleString }}
          id="kbArticleUpdatedOn"
          defaultMessage={messages.kbArticleUpdatedOn}
        />
      </p>
      <div
        key="border"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: article.htmlBody,
        }}
      />
    </div>
  );
};

export default KBArticle;
